export default [{group:'text',types:['!csv','!rtf']}]